/** Friendly 404 inside the shell — a wrong hash route is not a blank page. */
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Stack } from "@mui/material";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import { PageHeader } from "../components/ui/PageHeader";
import { EmptyState } from "../components/ui/EmptyState";
import { usePageTitle } from "../hooks/usePageTitle";

export function NotFoundPage() {
  const { t } = useTranslation();
  usePageTitle("notFound.title");
  const navigate = useNavigate();
  return (
    <Stack spacing={2}>
      <PageHeader title={t("notFound.title")} />
      <EmptyState
        icon={<SearchOffIcon fontSize="large" />}
        message={t("notFound.message")}
        actionLabel={t("common.home")}
        onAction={() => navigate("/")}
      />
    </Stack>
  );
}
